//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { useState } from 'react';
import styled from 'styled-components';

import { ItemProductSearchResult } from '@apis/universal-image-actions/universalImageActionsApiModel';
import {
  BodySecondaryText,
  BodyText,
  MetatagText,
} from '@components/atoms/text/Text';
import { UiaProductItem } from '@uia/products/UiaProductItem';
import {
  MAX_NUM_CATALOG_SUGGESTIONS,
  MAX_NUM_PRODUCTS,
  ProductResultsTypes,
} from '@uia/products/constants/UiaProductConstants';
import { pluralize } from '@utils/stringUtils';

export const UiaProductGrid = () => {
  const [selectedProducts, setSelectedProducts] = useState<
    ItemProductSearchResult[]
  >([]);

  // TODO: PD-284075 - get list of products
  const productsList: ItemProductSearchResult[] = [];
  // TODO: PD-284075 - get product result type
  const productResultsType: ProductResultsTypes =
    ProductResultsTypes.CATALOG_SUGGESTIONS;

  const isCatalogSuggestions =
    productResultsType === ProductResultsTypes.CATALOG_SUGGESTIONS;

  const isCatalogResults = false;
  // TODO: PD-284075 - uncomment below when we get productResultsType.
  // Currently setting it to false to avoid this error: 'ProductResultsTypes.CATALOG_SUGGESTIONS' and 'ProductResultsTypes.CATALOG_RESULTS' have no overlap
  // const isCatalogResults =
  //   productResultsType === ProductResultsTypes.CATALOG_RESULTS;

  const products = isCatalogSuggestions
    ? productsList.slice(0, MAX_NUM_CATALOG_SUGGESTIONS)
    : productsList;

  const productSuggestionCount = Math.min(
    MAX_NUM_CATALOG_SUGGESTIONS,
    productsList.length,
  );

  const selectProduct = (product: ItemProductSearchResult) => {
    // TODO: PD-284077 - select a product
  };

  return (
    <>
      {productsList.length > 0 && (
        <div>
          {isCatalogSuggestions && (
            <CatalogSuggestionsWrapper>
              <CatalogSuggestionsText>
                <MetatagText>Detected Products</MetatagText>
                <BodySecondaryText>
                  {productSuggestionCount} Items
                </BodySecondaryText>
              </CatalogSuggestionsText>
            </CatalogSuggestionsWrapper>
          )}
          {isCatalogResults && (
            <BodyText>
              {productsList.length >= MAX_NUM_PRODUCTS
                ? `Showing top ${productsList.length} products`
                : pluralize(productsList.length, 'Product')}
            </BodyText>
          )}
        </div>
      )}

      <ProductGrid>
        {products.map((product) => (
          <UiaProductItem
            key={product.destinationUrl}
            isSelected={selectedProducts.some(
              (item) => item.productStyleId === product.productStyleId,
            )}
            product={product}
            resultsType={productResultsType}
            selectProduct={() => selectProduct(product)}
          />
        ))}
      </ProductGrid>
      {/* // TODO: PD-284076 - add empty states / loading states / error states */}
    </>
  );
};

const ProductGrid = styled.div(
  ({ theme }) => `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${theme.spacings[3]};
  `,
);

const CatalogSuggestionsText = styled.div(
  ({ theme }) => `
    display: flex;
    gap: ${theme.spacings[2]};
  `,
);

const CatalogSuggestionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
